import styles from "./VisitHistoryList.module.css";
const VisitHistoryList = ({ data }) => {
  while (data.length < 3) {
    data.push({
      date: "",
      studio: "",
      plan: "",
    });
  }
  console.log("comes here");
  return (
    <div className={styles.visit_history_list_container}>
      {Array.isArray(data) &&
        data.length > 0 &&
        data.map((item, index) => {
          if (item.date === "") {
            return <div key={index} className={styles.single_row}></div>;
          }
          return (
            <div key={index} className={styles.single_row}>
              <div className={styles.tagLabel}>ご来店日</div>
              <div className={styles.tag1}>{item.date}</div>
              <div className={styles.tagLabel}>スタジオ</div>
              <div className={styles.tag2}>{item.studio}</div>
              <div className={styles.tagLabel}>プラン</div>
              <div className={styles.tag3}>{item.plan}</div>
            </div>
          );
        })}
    </div>
  );
};
export default VisitHistoryList;
